import * as React from "react";

export const ProgressUp = (props: any) => {
  return (
    <svg
      width={15}
      height={8}
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 7.5L7.5 0 15 7.5H0z" fill="#0AC68B" />
    </svg>
  );
};

export const ProgressDown = (props: any) => {
  return (
    <svg
      width={15}
      height={8}
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0l7.5 7.5L15 0H0z" fill="#FF5252" />
    </svg>
  );
};

export const ProgressSame = (props: any) => {
  return (
    <svg
      width={15}
      height={3}
      viewBox="0 0 15 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0v3h15V0H0z" fill="#B4BABE" />
    </svg>
  );
};
